import { productFilters } from 'components/Blotters/Filter/BlotterFilterNext.helpers';

import type { FilterPayload } from '../../../../apiConnector/blotters';
import type { IQuoteBlotterFilters } from '../../../../state/blotters/quote';
import { initialQuoteBlotterFilters } from '../../../../state/blotters/quote';

export function toFilterState(response: FilterPayload | undefined): IQuoteBlotterFilters {
  if (!response || !response.data) {
    return initialQuoteBlotterFilters;
  }

  switch (response.version) {
    case 1:
      return sanitizeQuoteBlotterFiltersProperties(response.data, initialQuoteBlotterFilters);
    default:
      return initialQuoteBlotterFilters;
  }
}

function sanitizeQuoteBlotterFiltersProperties(
  data: unknown,
  defaultValue: IQuoteBlotterFilters,
): IQuoteBlotterFilters {
  if (!data) {
    return defaultValue;
  }

  const knownKeys: string[] = [];
  for (const key in defaultValue) {
    if (Object.prototype.hasOwnProperty.call(defaultValue, key)) {
      knownKeys.push(key);
    }
  }

  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key) && !knownKeys.includes(key)) {
      delete (data as any)[key];
    }
  }

  const filters = data as IQuoteBlotterFilters;

  if (!productFilters.includes(filters.productFilter)) {
    filters.productFilter = 'allProducts';
  }

  return { ...defaultValue, ...filters };
}
